import React, { SVGProps } from 'react';

export const IconBolt = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="M19.8 3.63c.1-.56-.63-.87-.96-.4L8.1 18.33c-.25.35 0 .83.43.83h5.43l-1.75 9.21c-.1.56.62.87.95.4l10.74-15.1a.53.53 0 0 0-.43-.83h-5.43l1.75-9.21Z"/></svg>;
